"use client";

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createSession } from "../../api/session.api";

const CreateSession = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { domeData: dome } = location.state || {};
  console.log("🚀 ~ CreateSession ~ dome:", dome);

  const [sessionData, setSessionData] = useState({
    name: "",
    startTime: "",
    duration: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Generic input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSessionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Convert time to "10:45 AM" format
  const handleTimeChange = (e) => {
    const [hour, minute] = e.target.value.split(":");
    let formattedHour = parseInt(hour, 10);
    const period = formattedHour >= 12 ? "PM" : "AM";
    formattedHour = formattedHour % 12 || 12;
    const formattedTime = `${formattedHour}:${minute} ${period}`;
    setSessionData((prev) => ({ ...prev, startTime: formattedTime }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = {
        domeRef: dome._id,
        name: sessionData.name,
        startTime: sessionData.startTime,
        duration: parseInt(sessionData.duration),
      };

      const response = await createSession(data);
      console.log("✅ Session created:", response);
      navigate(-2); // Go back to previous page
    } catch (err) {
      console.error(err);
      setError(err?.message || "Failed to create session");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>
        Create Session for:{" "}
        <span className="text-primary">{dome?.domeName}</span>
      </h2>

      <form onSubmit={handleSubmit} className="mt-3">
        {/* Session Name */}
        <div className="mb-3">
          <label className="form-label">Session Name</label>
          <input
            type="text"
            name="name"
            value={sessionData.name}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

        {/* Start Time & Duration */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Time</label>
            <input
              type="time"
              name="startTime"
              onChange={handleTimeChange}
              className="form-control"
              required
            />
            {sessionData.startTime && (
              <small className="text-muted">
                Selected Time: {sessionData.startTime}
              </small>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Duration (minutes)</label>
            <input
              type="number"
              name="duration"
              value={sessionData.duration}
              onChange={handleChange}
              className="form-control"
              min={1}
              required
            />
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Creating..." : "Create Session"}
        </button>
      </form>
    </div>
  );
};

export default CreateSession;
